"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
/**
 * A pseudo-JSX string interpolation identifier.
 */
var IDENTIFIER = /<(\d+)\/>/;
/**
 * A function to enhance Polyglot.js to allow React component interpolations.
 *
 * @param originalT The original t function from Polyglot.js.
 * @returns The enhanced t function.
 */
var enhanceT = function (originalT) {
    // We use a named function here to aid debugging
    // ReactNode includes all React render-ables, including arrays
    function t() {
        var _a = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _a[_i] = arguments[_i];
        }
        var key = _a[0], interpolations = _a[1];
        if (interpolations === undefined || typeof interpolations === 'number') {
            return originalT(key, interpolations);
        }
        else {
            // ReactElement used because cloneElement requires a proper ReactElement
            var elementCache_1 = [];
            Object.keys(interpolations).forEach(function (key) {
                // Store all JSX elements into an array cache for processing later
                if (React.isValidElement(interpolations[key])) {
                    elementCache_1.push(interpolations[key]);
                    interpolations[key] = "<" + (elementCache_1.length - 1) + "/>";
                }
            });
            var tString = originalT(key, interpolations);
            // We can safely return if we don't need to do any element interpolation
            if (!elementCache_1.length) {
                return tString;
            }
            // Split the string into chunks of strings and interpolation indices
            var tChunks = tString.split(IDENTIFIER);
            // Move the leading string part into the render array and pop it
            var renderItems = tChunks.splice(0, 1);
            for (var i = 0; i < Math.ceil(tChunks.length); i += 1) {
                var _b = tChunks.splice(0, 2), index = _b[0], trailingString = _b[1];
                var currentIndex = parseInt(index, 10);
                var currentElement = elementCache_1[currentIndex];
                // Interpolate the element
                renderItems.push(React.cloneElement(currentElement, 
                // We need a unique key when rendering an array
                { key: currentIndex }, currentElement.props.children));
                // Interpolate any trailing string
                if (trailingString) {
                    renderItems.push(trailingString);
                }
            }
            return renderItems;
        }
    }
    return t;
};
exports.default = enhanceT;
